import { _ep0, _mw0, command } from "../commandBuilder";
import { CreateOAuth2Token$ } from "../schemas/schemas_0";
export class CreateOAuth2TokenCommand extends command(_ep0, _mw0, "CreateOAuth2Token", CreateOAuth2Token$) {
}
